import React from 'react';
import classNames from 'classnames';
import { IconLoader2 } from '@tabler/icons-react';
import { getCardStatusLabel } from '@entities/messanger';
import { useCardAction } from '../model/use-card-action';
import s from './interactive-message.module.scss';

// Общая разметка карточек-предложений в чате (слот / пакет).
// Информация в карточке одинаковая для преподавателя и ученика —
// отличаются только действия: кнопки бэк присылает только получателю.
export const OfferCard = ({ icon, title, status, children, actions = [], message }) => {
  const { run, pendingKey } = useCardAction(message?.chat_id);
  const showStatus = status && status !== 'active';

  return (
    <div className={s.offerCard}>
      <div className={s.header}>
        {icon && <span className={s.icon}>{icon}</span>}
        <span className={s.title}>{title}</span>
        {showStatus && (
          <span className={classNames(s.statusBadge, s[status])}>
            {getCardStatusLabel(status)}
          </span>
        )}
      </div>

      {children}

      {actions.length > 0 && (
        <div className={s.actions}>
          {actions.map((action) => {
            const isPending = pendingKey === `${message?.id}:${action.key}`;
            const isDisabled = isPending || action.disabled;
            return (
              <button
                key={action.key}
                type="button"
                className={s.actionBtn}
                disabled={isDisabled}
                title={action.disabled ? action.disabledReason : undefined}
                onClick={() => run(action, message)}
              >
                {isPending ? (
                  <IconLoader2 size={16} className={s.spin} />
                ) : (
                  action.label
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
